// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, executeAwaitableHandlerChain, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { DispatchCompleteLoadPurchasedProducts, LoadProducts, chain } from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";
import loadProducts from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";
import { getProductsDataView } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { xCommonUpdate } from "@vanmeter/App/Handlers/XNG/Common";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

export const xLoadProducts: typeof LoadProducts = async props => {
    const parameter = props.parameter.getProductCollectionParameter;
    if (!parameter) {
        return false;
    }

    const productsDataViewState = getProductsDataView(props.getState(), parameter);
    if (productsDataViewState.isLoading) {
        props.dispatch({
            type: "Components/ProductInfoLists/SetWaitingForData",
            id: props.parameter.id,
            parameter: props.parameter.getProductCollectionParameter,
        });
        return false;
    }

    props.dataViewHasProducts = !!productsDataViewState.value;
    if (props.dataViewHasProducts) {
        props.products = [...productsDataViewState.value!];
    }

    if (props.products && !props.parameter.forceLoad) {
        return;
    }

    try {
        const customParams = (props.parameter as any).loadProductParams;
        // XNG-Changes:to prevent recall api for related products
        if (customParams) {
            const dataView = getProductsDataView(props.getState(), customParams);
            props.products = dataView?.value ? [...dataView.value] : [];

            props.pricingLoaded = true;
            props.dataViewHasProducts = true;
        } else {
            props.products = await executeAwaitableHandlerChain(loadProducts, parameter, props);
        }
    } catch (error) {
        props.errorMessage = error as any;
    }
};
export const xDispatchAlsoPurchasedLoaded: typeof DispatchCompleteLoadPurchasedProducts = props => {
    if (getCurrentPage(props.getState()).type === "ProductDetailsPage" && props.parameter.getProductCollectionParameter.type === "alsoPurchased") {
        props.dispatch(xCommonUpdate({ key: "AlsoPurchasedProductsWidgetId", value: props.parameter.id }));
    }
};

replaceInChain(chain, LoadProducts, xLoadProducts);
addToChainAfter(chain, DispatchCompleteLoadPurchasedProducts, xDispatchAlsoPurchasedLoaded);
